import React, { useContext, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Textarea,
  Button,
  useToast,
  Flex,
} from "@chakra-ui/react";
import { useStepperContext } from "../../contexts/StepperContext";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Progress,
} from "@chakra-ui/react";
import FileUp from "../../../Rsop/FileUp.tsx";
import axios from "axios";

const Payment = (props) => {
  const [file, setFile] = useState(null);
  const [upload, setUploads] = useState([]);
  const [progress, setProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const formData = new FormData();

  const orderId = props.orderId;

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setUploads([...upload,selectedFile])
    console.log(selectedFile)
    // console.log(upload)
    // setFile(selectedFile);
    // setUploads(selectedFile)
    setProgress(0);
    // setUploadComplete(false);
    // uploadFile(selectedFile);
  };

  const uploadFile = (selectedFile) => {
    // Simulating file upload progress
    const interval = setInterval(() => {
      setProgress((prevProgress) => prevProgress + 10);
    }, 1000);

    // Simulating file upload completion
    setTimeout(() => {
      clearInterval(interval);
      setProgress(100);
      setUploadComplete(true);
      toast({
        title: "File Uploaded",
        description: `Successfully uploaded ${selectedFile.name}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      console.log("Uploaded file:", selectedFile.originFileObj);
    }, 10000);
  };

  const handleDelete = () => {
    setFile(null);
    setProgress(0);
    setUploadComplete(false);
    toast({
      title: "File Deleted",
      description: `Deleted ${file.name}`,
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleFileUpload = (file) => {
    // Perform your file upload logic here
    // You can make an API request or process the file in any way you need

    console.log("Uploading file:", file);
    // Add your file upload logic here
  };

  const { userData, setUserData } = useStepperContext();
  const toast = useToast();

  const handleChange = (event) => {
    const { name, value } = event.target;

    const wordCount = value.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount <= maxWordCount) {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: value }));
    } else {
      const truncatedValue = value
        .trim()
        .split(/\s+/)
        .slice(0, maxWordCount)
        .join(" ");

      setUserData((prevUserData) => ({
        ...prevUserData,
        [name]: truncatedValue,
      }));

      alert(
        `Word limit exceeded. Please limit your response to ${maxWordCount} words.`
      );
    }
  };

  const handleTextareaChange = (event, name) => {
    const inputValue = event.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount > maxWordCount) {
      toast({
        title: "Word Limit Exceeded",
        description: `Please limit your input to ${maxWordCount} words.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: inputValue }));
    }
  };


  const handleSubmit = async (event) => {
    console.log(orderId)
    upload.forEach(element => {
      formData.append('myfile', element)
    });
  // formData.append("orderId", orderId)
  console.log(formData)
    event.preventDefault();
    console.log(formData);
    axios.post(`https://glb-api.onrender.com/appforms/apform3?orderId=${orderId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then((result) => {
    console.log(result);
  }).catch((err) => {
    console.log(err);
  });

  };



  const getMaxWordCount = (name) => {
    // Add your logic to determine the max word count based on the name of the textarea
    // For example:
    switch (name) {
      case "q1":
        return 4;
      case "q2":
        return 2;
      case "q3":
        return 10;
      // Add cases for other text areas
      default:
        return 400;
    }
  };

  return (
    <Box mx="auto" mt="4">
      <Heading as="h1" size="xl" mb="4">
        Document requirement for Canada Visa SOP
      </Heading>
      <form onSubmit={handleSubmit} enctype="multipart/form-data">

        <Box mb="6">
          <Text p="5">2. Upload your updated Passport</Text>
          <input type="file" onChange={handleFileChange}></input>
          {/* <FileUp onChange={file} /> */}
        </Box>

        <Box mb="6">
          <Text p="5">2. Upload your updated Passport</Text>
          <input type="file" onChange={handleFileChange}></input>
          {/* <FileUp onChange={file} /> */}
        </Box>

        <Button type="submit" colorScheme="blue">
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default Payment;